export enum CoreStorageKeys {
  cashRegister = "cashRegisterId",
  kioskConfig = "kiosk_settings",
  accessToken = "access_token",
  expiresAt = "expires_at",
  expiresIn = "expires_in"
}
